<template>
  <v-container>
    <v-row>
      <v-col class="instalation">
        <p
          :class="{
            'display-2': $vuetify.breakpoint.mdAndUp,
            'display-1': $vuetify.breakpoint.smAndDown,
          }"
          class="font-weight-bold"
        >
          Instalación
        </p>
        <p class="mt-10 mb-5 headline">
          Instalar el conector en el ordenador donde tenga instalado
          <span class="program">{{ selected_program }}</span>
        </p>
        <div class="mt-2 mb-5 headline">
          <a
            :href="exe_link"
            target="_blank"
            color="#FFF"
          >
            Descarga el programa de este enlace
          </a>
        </div>

        <v-row class="text-center">
          <v-col lg="3">
            <img width="260" src="/install_steps/step_1.jpg" />
            <p>Clicamos Sí</p>
          </v-col>
          <v-col lg="3">
            <img width="260" src="/install_steps/step_2.jpg" />
            <p>INSTALAR</p>
          </v-col>
          <v-col lg="3">
            <img width="260" src="/install_steps/step_3.jpg" />
            <p>TERMINAR</p>
          </v-col>
          <v-col lg="3">
            <img width="260" src="/install_steps/step_4.jpg" />
            <p>Usuario y contraseña de Inmatic</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="12" offset-md="8" md="2">
        <v-btn block @click="cancel">Cancelar</v-btn>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          :disabled="submitting"
          block
          type="submit"
          color="secondary"
          @click="nextStep"
        >
          Siguiente
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { user as api_user } from "@/api/user";
import { STATUS } from "../../store/modules/me";

export default {
  name: "Installation",
  components: {},
  data() {
    return {
      valid: false,
      submitting: false,

      crispMsg: "Instalación",
    };
  },
  methods: {
    previousStep() {
      this.$emit("previousStep");
    },
    async cancel() {
      try {
        const response = await api_user.setUserInfo({
            status: STATUS.ACTIVE
        });
        this.setUserData(response.data.results);
        if (this.currentCompany) {
          this.$router.push('/' + this.currentCompany + '/documents');
        } else {
          this.$router.push("/initial");
        }
      } catch (error) {

      }
    },
    async nextStep() {
      this.submitting = true;
      try {
        const response = await api_user.setUserInfo({
          status: STATUS.FILLING_PROGRAM_DATA,
        });
        await api_user.createLead({'state': 'signup4'});
        this.setUserData(response.data.results);
        this.endCrispThread(this.crispMsg);
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
    ...mapActions({
      setUserData: "me/setUserData",
      setExeLink: "tutorial/setExeLink",
      startCrispThread: "me/startCrispThread",
      endCrispThread: "me/endCrispThread",
      setPrograms: "tutorial/setPrograms",
    }),
    ...mapState([
      'currentCompany'
    ])
  },
  mounted() {
    if (!this.programas.length) {
      this.setPrograms();
    }
    this.setExeLink();

    this.startCrispThread(this.crispMsg);
  },
  computed: {
    ...mapGetters({
      userData: "me/userData",
      programas: "tutorial/programs",
      exe_link: "tutorial/exe_link",
    }),
    selected_program() {
      let programa = '';
      for (let i in this.programas) {
        if (this.programas[i].id == this.userData.selected_program) {
          programa = this.programas[i].name;
        }
      }
      return programa;
    }
  },
};
</script>
<style scoped>
.program {
  text-transform: capitalize;
  color: yellow;
}
a {
  color: white !important;
}
@media screen and (max-width: 960px) {

  .instalation {
    padding: 0 !important;
  }

}
</style>
